import React from 'react';

import PropTypes from 'prop-types';


import { CardRowContainer } from '@src/components/common/containers/cardRow';
import { EmptyArticlesPromoCard } from '@src/components/promoCards/EmptyPromoCards';
import { TileContainerBasic } from '@src/components/TileContainerBasic';
import { imageOrDefault } from '@src/utils/defaultImage';

const fixEmptyCardSlots = (articles) => {
    const response = [];
    for (let i = 0; i < 4 - articles; i++) {
        response.push(
            <EmptyArticlesPromoCard
                key={`empty-training-card-${i}`}
                customClass="empty_training_card"
            />,
        );
    }

    return response;
};

/**
 * TrainingsRow row of trainings cards
 * @param {object} trainingContent Redux training courses data
 */
export const TrainingsRow = (props) => {
    const {
        trainings,
    } = props;

    return (
        <CardRowContainer>
            {
                trainings.map((training) => (
                    <TileContainerBasic
                        key={`training-${training.id}`}
                        {...training}
                        image={imageOrDefault(training.image)}
                    />
                ))
            }
            {
                trainings.length < 4
                && fixEmptyCardSlots(trainings.length)
            }
        </CardRowContainer>
    );
};

TrainingsRow.propTypes = {
    trainings: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
    })).isRequired,
};

export default TrainingsRow;
